module.exports = __webpack_public_path__ + "static/media/certified.038d212b.png";